var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "px-[5rem]"
  }, [_c('div', {
    staticClass: "heading text-white mb-[2rem]"
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.heading1))
    }
  }), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t(_vm.heading2))
    }
  })]), _c('div', {
    staticClass: "title gph-underline text-white !text-[24px] !font-normal"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.title)) + " ")]), _c('div', {
    staticClass: "text-white mb-[1rem]"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.description)) + " "), _vm._t("description")], 2), _c('div', [_vm._t("default")], 2)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };